import React from 'react';
import { Link } from 'react-router';
import { useTrendingSearchResults } from '../hooks/use-trending-search-results';
import { useSearchTracking } from '~/ui-rocco/hooks/use-search-tracking';

interface MobileSearchTrendingProps {
    /**
     * Context where the component is being used
     * - 'modal': Inside the mobile search modal (no padding)
     * - 'page': On the mobile search page (with padding)
     */
    context?: 'modal' | 'page';
}

/**
 * Renders the "Trending" list for mobile search modal.
 * Shows the top 5 trending search results with title and links.
 */
export const MobileSearchTrending: React.FC<MobileSearchTrendingProps> = ({
    context = 'page',
}) => {
    const { trendingSearchResults } = useTrendingSearchResults();
    const trackingConfig = useSearchTracking();

    if (!trendingSearchResults?.length) {
        return null;
    }

    // Use padding only for search page context, not for modal
    const containerClassName = context === 'modal' ? '' : 'px-6 md:px-0';

    return (
        <div className={containerClassName}>
            <h3 className="text-base font-medium">Trending</h3>
            <ul className="my-4.5 space-y-2.5">
                {trendingSearchResults.map((result) => (
                    <li key={result.id} className="w-auto text-left">
                        <Link
                            to={
                                result.link ??
                                `/search?search=${encodeURIComponent(result.title)}`
                            }
                            className="block min-h-4.5 max-w-full text-left leading-[1.1] text-[#9b9b9b]"
                            onClick={() => {
                                trackingConfig.onSearchTrendingClick(
                                    result.title,
                                );
                            }}
                        >
                            {result.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};
